// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/index.js';
import VueCropper from 'vue-cropper'; // 裁剪 
import VueClipboard from "vue-clipboard2"; // 复制
import VDistpicker from "v-distpicker";
import fetch from "./utils/fetch";
import tsTitle from "./components/title";
import newTitle from "./components/new-title";
import install from './directive/loading/Loading'
import { site } from "./utils/site";
import { getCookie } from './assets/js/cookie.js'


Vue.config.productionTip = false

console.log(process.env.NODE_ENV)

//路由守卫
router.beforeEach(function (to, from, next) {
  if (to.meta.needLogin) {
    //本地开发环境获取不到cookie
    //本地存储中是否有token(uid)数据
    let uid = getCookie("uid");
    let gid = getCookie("gid");
    if (uid != 0 && uid != null) { // 已登录
      if (to.meta.gid == 0) { // 普通用户可进入
        gid == 1 || gid == 2 ? router.replace({ path: "/index" }) : next();
      } else if (to.meta.gid == 1) { // 律师可进入
        gid == 1 || gid == 2 ? next() : router.replace({ path: "/consumer" });
      } else {
        next();
      }
    } else {
      //跳转到登录页
      if (process.env.NODE_ENV === 'development') {
        next();
      } else {
        window.location.href = site.uc.url() + 'pub/wlogin'
      }
    }
  } else {
    //表示不需要登录
    next();
  }
});


Vue.use(install)
Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.use(VueClipboard);
Vue.component('v-distpicker', VDistpicker);
Vue.component('ts-title', tsTitle);
Vue.component('new-title', newTitle);

Vue.prototype.$fetch = fetch

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js